import React, { useRef, useState, useEffect } from 'react'
import { useReactToPrint } from 'react-to-print'
import { ticketPageStyle, printContinuousTicket } from '../../../../utils/ticketPrintStyle'
import { Button, Divider, message } from 'antd'
import { VentaTicketFactura } from './VentaTicketFactura'
import { VentaCartaComanda } from './VentaCartaComanda'
import { VentaTicketComanda } from './VentaTicketComanda'
import PosSrc from '../../PosSrc'


const ContentModalMain = ({ sellShow, getSell, getProductsNotAvailable, companyCountryName }) => {
  const [total, setTotal] = useState(0)
  const [flag, setFlag] = useState(false)  

  const returnPrint = (key) => {
    switch (key) {
      case 1:
        return <VentaTicketFactura ref={componentRef} getSell={getSell} />
      case 2:
        return <VentaCartaComanda ref={componentRef} getSell={getSell} />
      case 3:
        return <VentaTicketComanda ref={componentRef} getSell={getSell} />
      default:
        break;
    }
  }

  // eslint-disable-next-line
  useEffect(() => { if (componentRef.current) handlePrint() }, [total, flag])

  const componentRef = useRef();
  const printWidthMm = getSell?.store?.ticket_print_width === '3' ? 80 : 58
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: ticketPageStyle,
    print: printContinuousTicket,
  })

  const facturaToPrint = async (sellShow) => {
    // Se abre la pestaña ya, de forma síncrona con el click, para que el
    // navegador no la bloquee como popup; la URL real se setea al llegar.
    const invoiceWindow = window.open('', '_blank')

    try {
      const response = await PosSrc.getInvoiceDocumentUrl(sellShow.id)
      if (response?.url) {
        invoiceWindow.location.href = response.url
      } else {
        invoiceWindow.close()
        message.error('No se pudo obtener el documento de la factura')
      }
    } catch (err) {
      console.log(err)
      invoiceWindow.close()
      message.error('No se pudo obtener el documento de la factura')
    }
  }

  const handleFlagPrint = (key) => {
    setTotal(key)
    setFlag(!flag)
  }

  return (
    <div style={{ textAlign: 'center' }}>
      {/* fuera de pantalla pero medible (no display:none) para calcular la altura real antes de imprimir */}
      <div style={{ position: 'fixed', top: 0, left: '-99999px', visibility: 'hidden', width: `${printWidthMm}mm` }}>{returnPrint(total)}</div>
      {
        sellShow?.status_dte === 'CERTIFIED' && getSell?.sell_invoice?.email ?
          <>
            <span style={{ fontSize: 'x-large' }} className='ant-modal-confirm-title'>Factura enviada</span>
            <p>{`Su factura se envió exitosamente a la siguiente dirección: ${getSell?.sell_invoice?.email}`}</p>
          </>
          : <></>
      }
      <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
      <br></br>
      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <Button style={{ marginBottom: '1rem' }} className="title-tendero new-button" onClick={() => handleFlagPrint(1)}>
          Imprimir ticket
        </Button>
        {sellShow?.status_dte === 'CERTIFIED' && (
          <Button style={{ marginBottom: '1rem' }} className="title-tendero new-button" onClick={() => facturaToPrint(sellShow)}>
            Imprimir factura electrónica
          </Button>
        )}
        {getSell?.store?.allow_delivery_order ? (
          <Button style={{ marginBottom: '1rem' }} className="title-tendero new-button" onClick={() => {sellShow.store.company.country.name === 'Honduras' ? handleFlagPrint(2) : handleFlagPrint(3)}}>
            Imprimir comanda de entrega
          </Button>
        ) : <></>}
        <Button onClick={() => getProductsNotAvailable()} style={{ backgroundColor: "rgb(205, 205, 205)", color: 'white', borderColor: '#cdcdcd' }} className="title-tendero new-button" >
          Ver inventario bajo
        </Button>
        {!getSell?.sell_invoice?.fel_hondura && companyCountryName === 'Honduras' && <span style={{ color: 'red', marginTop: '1rem', fontSize: 'large' }} >{'No posee ninguna credencial activa para Honduras'}</span>}
      </div>
    </div >
  )
}

export default ContentModalMain